import React, { useState } from 'react';
import { Input, Row, Co, message, Upload } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { BASE, AVATARS, USERS } from 'api';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import request from 'utils/request';
import Modal from '../../../components/Modal/index';
import { Button, Form } from 'antd';

const Wrapper = styled.div`
  &&& {
    padding: 14px 20px 14px 20px;
    .ant-select-selector {
      height: 50px;
      display: flex;
      align-items: center;
      padding-left: 20px;
      border-radius: 6px;
      .ant-select-selection-search {
        display: flex;
        align-items: center;
      }
    }
    .ant-checkbox-inner {
      border-radius: 4px;
    }
    .ant-radio-group.ant-radio-group-outline {
      width: 98%;
      padding-left: 1px;
    }
    .ant-radio-button-wrapper {
      border: 1px solid #e2e3e3;
      border-radius: 6px;
      &:before {
        display: none;
      }
    }
    .ant-radio-button-wrapper-checked {
      border-color: #4b97e9;
    }
    .ant-picker-input {
      input {
        font-style: italic;
      }
    }
  }
`;

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};

function AddManager({ visible, setVisible, getData }) {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const [imgUrl, setImgUrl] = useState({
    loading: false,
    url: null,
  });
  const [validEmail, setValidEmail] = useState(false);

  const getUploadProps = () => {
    return {
      name: 'file',
      action: `v1${AVATARS}`,
      headers: {
        Authorization: `OAuth ${localStorage.getItem('access_token')}`,
      },
      showUploadList: false,
      listType: 'picture-card',
      className: 'avatar-uploader',
      onChange({ file }) {
        if (file.status === 'uploading') {
          setImgUrl({ ...imgUrl, loading: true });
          return;
        }
        if (file.status === 'done') {
          setImgUrl({ loading: false, url: file.response });
        } else if (file.status === 'error') {
          message.error(`${file.name} file upload failed.`);
        }
      },
    };
  };

  const uploadButton = (
    <div>
      {imgUrl.loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>{t('uploadPhoto')}</div>
    </div>
  );

  const validateEmail = (email) => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const saveChange = async (data) => {
    if (validateEmail(data.email)) {
      if (imgUrl.url) {
        const response = await request(`v1${USERS}`, {
          method: 'post',
          data: { ...data, avatar: imgUrl.url, role: 'manager' },
        });

        getData({
          role: 'manager',
        });
        setVisible(false);
      } else {
        const response = await request(`v1${USERS}`, {
          method: 'post',
          data: { ...data, role: 'manager' },
        });
        setVisible(false);
        getData({
          role: 'manager',
        });
      }
    } else {
      setValidEmail(true);
    }
  };
  const resetFields = () => {
    form.resetFields();
  };

  const afterClose = () => {
    resetFields();
    setValidEmail(false);
  };

  const validateMessages = {
    required: '${label} is required!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!',
    },
    number: {
      range: '${label} must be between ${min} and ${max}',
    },
  };

  return (
    <Modal
      afterClose={afterClose}
      width={727}
      visible={visible}
      setVisible={setVisible}
    >
      <Wrapper>
        <div className="text-17 font-semibold text-black h-41 flex items-center">
          {t('addTenant')}
        </div>
        <Form
          form={form}
          {...layout}
          name="nest-messages"
          onFinish={saveChange}
          validateMessages={validateMessages}
        >
          <Form.Item>
            <Upload {...getUploadProps()}>
              {imgUrl.url ? (
                <div
                  style={{
                    width: '100%',
                    backgroundImage: `url(${BASE}${imgUrl.url})`,
                    height: '100%',
                    backgroundSize: 'cover',
                    borderRadius: '100px',
                  }}
                />
              ) : null}
              {!imgUrl.url ? uploadButton : null}
            </Upload>
          </Form.Item>
          <Form.Item
            name={['first_name']}
            label="First name"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={['last_name']}
            label="Last name"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={['email']}
            label="Email"
            rules={[
              {
                type: 'email',
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="password"
            label="Password"
            rules={[
              {
                required: true,
                message: 'Please input your password!',
              },
            ]}
            hasFeedback
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="phone"
            label="Phone Number"
            rules={[
              {
                required: true,
                message: 'Please input your phone number!',
              },
            ]}
          >
            <Input
              // addonBefore={prefixSelector}
              style={{
                width: '100%',
              }}
            />
          </Form.Item>
          <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 8 }}>
            <Button type="primary" htmlType="submit">
              Create
            </Button>
            <Button onClick={resetFields}>Clear</Button>
          </Form.Item>
        </Form>
      </Wrapper>
    </Modal>
  );
}

AddManager.propTypes = {};

export default AddManager;
